import baseAPI from "@/api/base";
import { GET_ROLE_PERMISSIONS_URL, UPDATE_ROLE_PERMISSIONS_URL } from "@/utils/urls";
import { Permission } from "@/utils/permissions";
import { AxiosResponse } from "axios";

export interface RolePermissionsResponse {
  rolePermissions: Record<string, Permission[]>;
  permissionDetails: Array<{
    key: Permission;
    label: string;
    description: string;
    category: string;
  }>;
}

class PermissionService {
  static getRolePermissions = async (): Promise<AxiosResponse> => {
    return baseAPI.get(GET_ROLE_PERMISSIONS_URL);
  };

  static updateRolePermissions = async (
    role: string,
    permissions: Permission[]
  ): Promise<AxiosResponse> => {
    return baseAPI.put(UPDATE_ROLE_PERMISSIONS_URL(role), { permissions });
  };
}

export default PermissionService;
